import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import AppTheme from './app-theme';
import AppRoute from './app-route';
import AppConsult from './app-consult';
import AppLogin from './app-login';
import URI from 'urijs';
import '../lib/map/js/china';
import Question from '@/page/question';
import { getRegistrationAttribution } from '@lib/registration-attribution';

interface IProps { }
interface IState { }

const AppRoot = (props: IProps, state: IState) => {
  const uri = new URI(window.location.href);
  const path = uri.path(true);
  const { utm_params: utmParams } = getRegistrationAttribution(
    window.location.search,
    sessionStorage.getItem('registerQuery'),
  );
  if (utmParams) {
    const queryList = JSON.stringify(utmParams);
    sessionStorage.setItem('registerQuery', queryList);
  } else {
    sessionStorage.removeItem('registerQuery');
  }
  return (
    <AppTheme>
      {path !== '/effectpdf' && path !== '/index-pdf' && <AppConsult />}
      {path !== '/index-pdf' && <Question/> /* 为pdf导出页面时不增加调查问卷 */}
      <AppRoute />
      <ToastContainer style={{ zIndex: 9999999 }} />
    </AppTheme>
  );
};

export default AppRoot;
